import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ThreeDots } from "react-loader-spinner";
import SetupBirthDatePicker from "../dashBoardPages/SetupBirthDatePicker";
import "./ClientDatePicker.css";

export default function CustomSearchByDate({ onDateFilter, onReset, dateFilterLoading }) {
  // const [filterLoading, setFilterLoading] = useState(false);

  const validationSchema = Yup.object({
    start: Yup.date().required("Start date is required"),
    end: Yup.date()
      .required("End date is required")
      .min(Yup.ref("start"), "End date can't be before start date"),
  });

  const { touched, values, errors, handleSubmit, handleBlur, resetForm, setFieldValue } =
    useFormik({
      initialValues: {
        start: "",
        end: "",
      },
      validationSchema,
      validateOnBlur: false,
      validateOnChange: false,
      onSubmit: async (values) => {
        // setFilterLoading(true);
        await onDateFilter(values.start, values.end);
        // setFilterLoading(false);
      },
    });

  return (
    <form className="row align-items-center mb-4" onSubmit={handleSubmit}>
      {/* Start Date */}
      <div className="col-4">
        <label className="label-title" htmlFor="client-start-date">Start Date</label>
        <SetupBirthDatePicker
          id="client-start-date"
          name="start"
          value={values.start}
          onChange={(value) => setFieldValue("start", value)}
          onBlur={handleBlur}
          label="Choose start date"
          className="client-date-picker"
          menuClassName="client-date-picker-menu"
          portal
          showToday
        />
        <p className="text-danger mb-0" style={{ minHeight: "25px" }}>
          {touched.start && errors.start ? errors.start : ""}
        </p>
      </div>

      {/* End Date */}
      <div className="col-4">
        <label className="label-title" htmlFor="client-end-date">End Date</label>
        <SetupBirthDatePicker
          id="client-end-date"
          name="end"
          value={values.end}
          onChange={(value) => setFieldValue("end", value)}
          onBlur={handleBlur}
          label="Choose end date"
          className="client-date-picker"
          menuClassName="client-date-picker-menu"
          portal
          showToday
        />
        <p className="text-danger mb-0" style={{ minHeight: "25px" }}>
          {touched.end && errors.end ? errors.end : ""}
        </p>
      </div>

      {/* Submit & Reset Buttons */}
      <div className="col-4 d-flex align-items-end gap-2">
        <button
          className="btn_brnd client-date-apply"
          type="submit"
          disabled={dateFilterLoading}
          style={{ width: "max-content" }}
        >
          {dateFilterLoading ? (
            <ThreeDots
              height="14"
              width="38"
              radius="4"
              color="#4fa94d"
              ariaLabel="three-dots-loading"
              wrapperStyle={{ display: "block" }}
              wrapperClassName="spinner"
              visible={true}
            />
          ) : (
            "Apply Filter"
          )}
        </button>

        <button
          type="button"
          className="btn_brnd"
          onClick={() => {
            resetForm();
            onReset();
          }}
        >

          Reset
        </button>
      </div>
    </form>
  );
}
